module.exports = __webpack_public_path__ + "static/profile-photo-a9d708094ee620637c14cb7bc30d572a.png";